import { IconWithText } from 'common/icon/icon-with-text.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { IForecast } from './types.js';

export function ForecastFreezingLevel({ fzlStatement }: Pick<IForecast, 'fzlStatement'>) {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  // name="freezing-level-dark"
  if (fzlStatement) {
    return (
      <div data-module="forecast-freezing-level">
        <IconWithText
          icon="freezing-level"
          classes={`u-mB-sm svg-fill-textSlate u-mT-sm ${isLarge ? '' : 'IconWithText--small'}`}
        >
          <h4 className="u-mT-0 u-mB-0">Freezing level</h4>
          <p className="small u-mT-0 u-mB-0">{fzlStatement}</p>
        </IconWithText>
      </div>
    );
  }
  return null;
}
